import './styles.css';
import {
  type TooltipChildNodeProps,
  pickTooltipChildNodeProps,
} from '@ipfabric/ui-components/Tooltip/Tooltip';
import { type ReportSeverity, safeAbsurd } from '@ipfabric/utils';
import type { FC } from 'react';

import classNames from 'classnames';

type Props = TooltipChildNodeProps & {
  className?: string;
  faIcon?: string;
  severity: ReportSeverity;
};

const getIconSeverityColorClassName = (severity: ReportSeverity): string =>
  `severity-icon--${severity}`;
const getIconSeverityShapeClassName = (
  severity: ReportSeverity,
): string | null => {
  switch (severity) {
    case 0:
      return 'fa-check-circle';
    case 10:
      return 'fa-info-circle';
    case 20:
    case 30:
      return 'fa-exclamation-circle';
    default:
      safeAbsurd(severity, 'unknown severity');
      return 'fa-exclamation-circle';
  }
};

export const SeverityIcon: FC<Props> = (props) => (
  <i
    className={classNames(
      props.className,
      getIconSeverityColorClassName(props.severity),
      'fa',
      props.faIcon ?? getIconSeverityShapeClassName(props.severity),
      'fa-fw',
    )}
    {...pickTooltipChildNodeProps(props)}
  />
);
